import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-info-row',
  templateUrl: './info-row.component.html',
  styleUrls: ['./info-row.component.scss']
})
export class InfoRowComponent {
  @Input() labelIconLink?: string;
  @Input() label?: string;
  @Input() value?: string | null;
  @Input() link?: string;
  @Input() noValuePlaceholder?: string = '-';
  @Input() isLoading = false;
}
